import { useEffect, useRef } from 'react';
import { usePrimitiveCollection } from 'app/agriculture/FarmMain/MapRenderer/context/PrimitiveCollectionContext';

interface Props {
    primitiveOptions: Partial<Cesium.GroundPolylinePrimitive>;
}

export function CesiumGroundPolylinePrimitive({ primitiveOptions }: Props) {
    const collection = usePrimitiveCollection();

    useEffect(() => {
        const primitive = collection.add(
            new Cesium.GroundPolylinePrimitive(primitiveOptions),
        ) as Cesium.GroundPolylinePrimitive;

        return () => {
            if (collection.isDestroyed() || primitive == null) return;
            collection.remove(primitive);
        };
    }, [collection, primitiveOptions]);

    return null;
}
